<template>
    <b-modal v-model="localShow" size="xl" no-close-on-backdrop dialog-class="modal-dialog-left modal-lg" @hidden="onHidden">
        <template #modal-title>
            <div>
                <div class="fs-xl font-weight-bold">
                    {{ payment.id > 0 ? __t('EDIT_PAYMENT') : __t('CREATE_PAYMENT') }}
                </div>

                <div class="text-muted fs-sm" v-if="payment.pay_gate">
                    {{ payment.pay_gate.name }} / {{ payment.pay_gate.country_code }}
                </div>
            </div>
        </template>

        <div class="payment-item-modal">

            <info_field f_uniq="ct" f_type="name" @update_categ="change_atr" :f_title="__t('PAYMENT_NAME')" :is_disabled=false :f_val="payment.name" />
            <info_field f_uniq="ct-description" f_type="description" @update_categ="change_atr" :f_title="__t('PAYMENT_DESCRIPTION')" :is_disabled=false :f_val="payment.description" />

            <b-tabs pills card>
                <b-tab active>
                    <template #title>
                        <div class="px-3">
                            {{ __t('GENERAL_PARAMS') }}
                        </div>
                    </template>

                    <div v-for="fieldKey in paramFieldKeys" :key="fieldKey" class="mb-3">
                        <b-form-group :label="fieldLabel(fieldKey)">
                            <b-input-group>
                                <b-form-input
                                    v-if="isSecretField(fieldKey)"
                                    :type="showSecrets[fieldKey] ? 'text' : 'password'"
                                    v-model="payment.params[fieldKey]"
                                    :placeholder="fieldKey"
                                />

                                <b-form-input
                                    v-else
                                    v-model="payment.params[fieldKey]"
                                    :placeholder="fieldKey"
                                />

                                <b-input-group-append v-if="isSecretField(fieldKey)">
                                    <b-button
                                        variant="outline-secondary"
                                        @click="toggleSecret(fieldKey)"
                                    >
                                        <i :class="showSecrets[fieldKey] ? 'fal fa-eye-slash' : 'fal fa-eye'"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </div>

                    <div v-if="paramFieldKeys.length <= 0" class="alert alert-info">
                        Немає параметрів для цього шлюзу
                    </div>
                </b-tab>

                <b-tab >
                    <template #title><div class="px-3">{{ __t('ATTACHED_LOCATIONS') }}</div></template>
                    <payment_attached_locations @on_change_attribute="change_atr" :in_item="payment" />
                </b-tab>


                <b-tab v-if="hasSplit">
                    <template #title><div class="px-3">{{ __t('SPLIT_PAYMENT') }}</div></template>
                    <split_tab
                        :key="'split_' + payment.id + '_' + payment.pay_gate_id"
                        @on_change_attribute="change_atr" :payment="payment"></split_tab>
                </b-tab>


            </b-tabs>
        </div>

        <template v-slot:modal-footer="{ close }">
            <div class="payment-modal-footer">
                <div>
                    <b-button v-if="payment.id > 0" variant="outline-danger" :disabled="isSaving" @click="removePayment">
                        <i class="fal fa-trash mr-1"></i>
                        {{ __t('DELETE') }}
                    </b-button>
                </div>

                <div class="payment-modal-footer-actions">
                    <b-button variant="outline-secondary" :disabled="isSaving" @click="close">
                        {{ __t('CANCEL') }}
                    </b-button>

                    <b-button variant="primary" :disabled="isSaving" @click="save">
                        <i v-if="isSaving" class="fal fa-spinner fa-spin mr-1"></i>
                        <i v-else class="fal fa-save mr-1"></i>
                        {{ __t('SAVE') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>

import payment_attached_locations from "./pay_tabs/payment_attached_locations.vue";
import Info_field from "../../../sys/info_field.vue";
import Split_tab from "./split/split_tab.vue";
export default {
    name: "payment_item",

    components: {
        Split_tab,
        Info_field,
        payment_attached_locations,
    },

    data() {
        return {
            localShow: false,
            isSaving: false,
            showSecrets: {},

            payment: this.emptyPayment()
        }
    },

    created() {
        EventBus.$on('showPayment', this.showPayment);
    },

    beforeDestroy() {
        EventBus.$off('showPayment', this.showPayment);
    },

    methods: {
        emptyPayment() {
            return {
                id: 0,
                client_id: 0,
                cart_payment_id: 0,
                pay_gate_id: 0,
                name: '',
                description: '',
                params: {},
                pay_gate: null,
                split: {
                    split_payment_data: [],
                    split_template: [],
                    split_categories: []
                },
                attached_location_ids: [],
            };
        },

        showPayment(gateId, itemId = 0) {
            this.payment = this.emptyPayment();

            this.payment.id = parseInt(itemId || 0);
            this.payment.pay_gate_id = parseInt(gateId || 0);

            this.localShow = true;
            this.loadItem(gateId, itemId);
        },

        async loadItem(gateId, itemId = 0) {
            await api.get('/internal/v1/catalog/pwa/payments/gates/' + gateId + '/payment/' + itemId)
                .then(({data}) => {
                    if (data.status === 'operation_success') {
                        this.payment = this.normalizePayment(data.data);
                    }
                })
                .catch(({response}) => {
                    this.toast(
                        response?.data?.message || 'Payment load error',
                        'danger',
                        response?.data?.status || 'PWA Payments'
                    );
                });
        },

        change_atr(atr_name,atr_val) {
            console.log('change',atr_name,atr_val);
            if(this.payment.hasOwnProperty(atr_name)) {
                this.payment[atr_name] = atr_val;
            }
        },
        normalizePayment(item) {
            item = item || {};

            let params = this.clone(item.params || {});
            let split = item.split || params.split || {
                split_payment_data: [],
                split_template: [],
                split_categories: []
            };

            delete params.split;

            return {
                id: parseInt(item.id || 0),
                client_id: parseInt(item.client_id || 0),
                cart_payment_id: parseInt(item.cart_payment_id || 0),
                pay_gate_id: parseInt(item.pay_gate_id || item.pay_gate?.id || 0),
                name: item.name || '',
                description: item.description || '',
                params: params,
                pay_gate: item.pay_gate || null,
                pwa_payment: item.pwa_payment || null,
                split: this.normalizeSplit(split),
                attached_location_ids: this.normalizeIds(item.attached_location_ids || []),
            };
        },

        normalizeIds(ids) {
            if (!Array.isArray(ids)) {
                return [];
            }

            return ids
                .map(id => parseInt(id || 0))
                .filter(id => id > 0);
        },

        normalizeSplit(split) {
            if (!split || typeof split !== 'object') {
                return {
                    split_payment_data: [],
                    split_template: [],
                    split_categories: []
                };
            }

            return {
                split_payment_data: Array.isArray(split.split_payment_data)
                    ? split.split_payment_data
                    : [],

                split_template: Array.isArray(split.split_template)
                    ? split.split_template
                    : [],

                split_categories: Array.isArray(split.split_categories)
                    ? split.split_categories
                    : []
            };
        },

        buildPayload() {
            const params = this.cleanParams(this.payment.params);

            params.split = this.payment.split;

            return {
                id: this.payment.id,
                cart_payment_id: this.payment.cart_payment_id,
                pay_gate_id: this.payment.pay_gate_id,

                name: this.payment.name,
                description: this.payment.description,
                params: params,
                attached_location_ids : this.payment.attached_location_ids
            };
        },

        cleanParams(params) {
            const result = {};

            Object.keys(params || {}).forEach((key) => {
                const value = params[key];

                if (key === 'id' || key === 'pay_id') {
                    return;
                }

                if (value === null || value === undefined) {
                    return;
                }

                if (typeof value === 'string' && value.trim() === '') {
                    return;
                }

                result[key] = typeof value === 'string' ? value.trim() : value;
            });

            return result;
        },

        validate() {
            if (!this.payment.pay_gate_id) {
                this.toast('Не знайдено платіжний шлюз', 'warning');
                return false;
            }

            if (!this.payment.name || this.payment.name.trim().length <= 0) {
                this.toast('Вкажіть назву платежу', 'warning');
                return false;
            }

            return true;
        },

        async save() {
            if (!this.validate()) {
                return;
            }

            this.isSaving = true;

            const payload = this.buildPayload();

            const gateId = this.payment.pay_gate_id;
            const itemId = this.payment.id;

            const request =  api.put('/internal/v1/catalog/pwa/payments/gates/' + gateId + '/payment/' + itemId, payload);

            await request
                .then(({data}) => {
                    this.isSaving = false;

                    if (data.status === 'operation_success') {
                        EventBus.$emit('show_toast', {
                            err: data.message || 'Saved',
                            type: "success",
                            title: "PWA Payments"
                        });

                        this.$emit('saved', data.data);
                        this.localShow = false;
                    }
                })
                .catch(({response}) => {
                    this.isSaving = false;

                    this.toast(
                        response?.data?.message || 'Save error',
                        'danger',
                        response?.data?.status || 'PWA Payments'
                    );
                });
        },

        async removePayment() {
            if (this.payment.id <= 0) {
                return;
            }
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                this.isSaving = true;
                 api.delete('/internal/v1/catalog/pwa/payments/' + this.payment.id)
                    .then(({data}) => {
                        this.isSaving = false;
                        if (data.status === 'operation_success') {
                            this.$emit('deleted', this.payment.id);
                            this.localShow = false;
                        }
                    })
                    .catch(({response}) => {
                        this.isSaving = false;

                        this.toast(
                            response?.data?.message || 'Delete error',
                            'danger',
                            response?.data?.status || 'PWA Payments'
                        );
                    });
            });
        },

        fieldLabel(fieldKey) {
            return String(fieldKey).toUpperCase();
        },

        isSecretField(fieldKey) {
            return [
                'private_key',
                'secret_key',
                'client_secret',
                'token',
                'webhook_secret',
                'privat_key',
                'api_key'
            ].includes(fieldKey);
        },

        toggleSecret(fieldKey) {
            this.$set(this.showSecrets, fieldKey, !this.showSecrets[fieldKey]);
        },

        close() {
            this.localShow = false;
        },

        onHidden() {
            this.payment = this.emptyPayment();
            this.$emit('closed');
        },

        clone(value) {
            return JSON.parse(JSON.stringify(value || {}));
        },

        toast(message, type = 'info', title = 'PWA Payments') {
            EventBus.$emit('show_toast', {
                err: message,
                type: type,
                title: title
            });
        }
    },

    computed: {
        hasSplit() {
            return this.payment.split &&
                Array.isArray(this.payment.split.split_template) &&
                this.payment.split.split_template.length > 0;
        },

        paramFieldKeys() {
            return Object.keys(this.payment.params || {}).filter((key) => {
                return ![
                    'split',
                    'id',
                    'pay_id'
                ].includes(key);
            });
        },

        splitPaymentAdapter() {
            return {
                id: this.payment.id,
                payment_settings_id: this.payment.id,
                pay_gate_id: this.payment.pay_gate_id,
                split: this.payment.split
            };
        }
    }
}
</script>

<style scoped>
.setting-side-card {
    background: #f8f8fb;
    border: 1px solid #e6e6ef;
    border-radius: 6px;
    padding: 16px;
}

.payment-modal-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.payment-modal-footer-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.payment-modal-footer .btn {
    min-width: 92px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.gate-icon {
    max-width: 120px;
    max-height: 32px;
    overflow: hidden;
}

.gate-icon svg {
    max-width: 120px;
    max-height: 32px;
}
</style>
